import axios from '../../axios'

/*
 * 字典管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/berry-admin/dict/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/berry-admin/dict/delete',
        method: 'post',
        data
    })
}

// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/berry-admin/dict/findPage',
        method: 'post',
        data
    })
}

// 分页查询
export const selectList = (data) => {
  return axios({
    url: '/berry-admin/dict/selectList',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/admin/dict.js